import Preloader from "./components/Preloader";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Manifesto from "./components/Manifesto";
import CareAreas from "./components/CareAreas";
import LaserTherapy from "./components/LaserTherapy";
import Protocols from "./components/Protocols";
import HomeCare from "./components/HomeCare";
import PatientJourney from "./components/PatientJourney";
import Differentials from "./components/Differentials";
import Purpose from "./components/Purpose";
import InstagramFeed from "./components/InstagramFeed";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import HeroStrip from "./components/HeroStrip";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Preloader />
      <Header />
      <main>
        <Hero />
        <HeroStrip />
        <About />
        <Manifesto />
        <CareAreas />
        <LaserTherapy />
        <Protocols />
        <HomeCare />
        <PatientJourney />
        <Differentials />
        <Purpose />
        <InstagramFeed />
        <Testimonials />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}